import React, { useState } from 'react';
import axios from 'axios';
import './FeedbackModal.css';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const FeedbackModal = ({ isOpen, onClose, argument, debateId }) => {
  const [complaint, setComplaint] = useState('');
  const [suggestion, setSuggestion] = useState('');
  const [additionalComment, setAdditionalComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!complaint.trim() || !suggestion.trim()) {
      alert('Bitte fülle die Pflichtfelder aus');
      return;
    }

    setSubmitting(true);
    try {
      const sessionId = localStorage.getItem('session_id');
      
      await axios.post(`${API}/feedback/create`, {
        argument_id: argument.id,
        debate_id: debateId,
        session_id: sessionId,
        complaint: complaint.trim(),
        suggestion: suggestion.trim(),
        additional_comment: additionalComment.trim() || null
      });

      setSuccess(true);
      setTimeout(() => {
        onClose();
        // Reset form
        setComplaint('');
        setSuggestion('');
        setAdditionalComment('');
        setSuccess(false);
      }, 2000);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      alert('Fehler beim Senden des Feedbacks');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="feedback-modal-overlay" onClick={onClose}>
      <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
        <div className="feedback-modal-header">
          <h2>📝 Feedback zur AI-Bewertung</h2>
          <button className="feedback-close-btn" onClick={onClose}>✕</button>
        </div>

        {success ? (
          <div className="feedback-success">
            <div className="success-icon">✅</div>
            <p>Vielen Dank für dein Feedback!</p>
            <p className="success-subtext">Dein Feedback hilft uns, die AI zu verbessern.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* Context Display */}
            <div className="feedback-context">
              <div className="context-section">
                <label className="context-label">Dein Argument:</label>
                <div className="context-content">{argument.content}</div>
              </div>

              <div className="context-section">
                <label className="context-label">AI-Bewertung:</label>
                <div className="context-content">
                  <strong>Punkte:</strong> {argument.moderation_result?.score?.total_score || 0}<br />
                  <strong>Bewertung:</strong> {argument.moderation_result?.is_valid ? 'Valid' : 'Invalid'}<br />
                  {argument.moderation_result?.score?.tags && (
                    <><strong>Tags:</strong> {argument.moderation_result.score.tags.join(', ')}</>
                  )}
                </div>
              </div>
            </div>

            {/* Feedback Form */}
            <div className="feedback-form">
              <div className="form-group">
                <label htmlFor="complaint">
                  Was war an der Bewertung falsch? <span className="required">*</span>
                </label>
                <textarea
                  id="complaint"
                  value={complaint}
                  onChange={(e) => setComplaint(e.target.value)}
                  placeholder="z.B. 'Die AI hat mein Argument als Zirkelschluss bewertet, aber es ist ein konkretes Beispiel...'"
                  rows="4"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="suggestion">
                  Wie sollte die Bewertung richtig sein? <span className="required">*</span>
                </label>
                <textarea
                  id="suggestion"
                  value={suggestion}
                  onChange={(e) => setSuggestion(e.target.value)}
                  placeholder="z.B. 'Sollte als valid bewertet werden und +2 Punkte bekommen für Insight...'"
                  rows="3"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="additionalComment">
                  Zusätzlicher Kommentar (optional)
                </label>
                <textarea
                  id="additionalComment"
                  value={additionalComment}
                  onChange={(e) => setAdditionalComment(e.target.value)}
                  placeholder="Weitere Details..."
                  rows="2"
                />
              </div>

              <div className="form-actions">
                <button 
                  type="button" 
                  className="btn-cancel" 
                  onClick={onClose}
                  disabled={submitting}
                >
                  Abbrechen
                </button>
                <button 
                  type="submit" 
                  className="btn-submit"
                  disabled={submitting}
                >
                  {submitting ? 'Wird gesendet...' : 'Feedback senden'}
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackModal;
